import { b as getDefaultExportFromCjs, a as createCommonjsModule } from '../common/_commonjsHelpers-fdecda49.js';
import { i as interopRequireDefault } from '../common/interopRequireDefault-00cfe768.js';
import { c as classnames, j as jsxRuntime } from '../common/jsx-runtime-4342af96.js';
import { r as react } from '../common/index-59f32655.js';
import { a as Button } from '../common/Button-5308f59c.js';
import { T as ThemeProvider_1 } from '../common/ThemeProvider-76df4d0f.js';

var Button_1 = createCommonjsModule(function (module, exports) {
"use client";


exports.__esModule = true;
exports.default = void 0;
var _classnames = interopRequireDefault(classnames);
var React = _interopRequireWildcard(react);



function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Button$1 = /*#__PURE__*/React.forwardRef(({
  as,
  bsPrefix,
  variant = 'primary',
  size,
  active = false,
  disabled = false,
  className,
  ...props
}, ref) => {
  const prefix = (0, ThemeProvider_1.useBootstrapPrefix)(bsPrefix, 'btn');
  const [buttonProps, {
    tagName
  }] = (0, Button.useButtonProps)({
    tagName: as,
    disabled,
    ...props
  });
  const Component = tagName;
  return /*#__PURE__*/(0, jsxRuntime.jsx)(Component, {
    ...buttonProps,
    ...props,
    ref: ref,
    disabled: disabled,
    className: (0, _classnames.default)(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
  });
});
Button$1.displayName = 'Button';
var _default = exports.default = Button$1;
module.exports = exports.default;
});

var __pika_web_default_export_for_treeshaking__ = /*@__PURE__*/getDefaultExportFromCjs(Button_1);

export default __pika_web_default_export_for_treeshaking__;
